import * as React from 'react';

import { IBanner } from '../../models/content.interfaces';
import { PhoneNoPhone } from '../PhoneNoPhone/PhoneNoPhone';
import { BannerGraphic } from '../BannerGraphic/BannerGraphic';
import { BannerImage } from '../BannerImage/BannerImage';
import { IVerticalOffset } from '../Container';

export const BannerResponsive = ({ ...props }: IBanner & IVerticalOffset) => {
  const { postcodeEntry } = props;
  if (postcodeEntry) {
    return (
      <PhoneNoPhone
        phone={<BannerImage data-id="banner-image" {...props} />}
        noPhone={<BannerImage data-id="banner-image" {...props} />}
      />
    );
  }
  return (
    <PhoneNoPhone
      phone={<BannerGraphic data-id="banner-graphic" {...props} />}
      noPhone={<BannerImage data-id="banner-image" {...props} />}
    />
  );
};
